import React from 'react';
import { withTranslation } from 'react-i18next';
// material ui
import { PlayCircleOutlineOutlined } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import ReactPlayer from 'react-player'
// components
import { PhotoPreview } from './index';

const useStyles = makeStyles({
    mainDiv:props=> ({
        width:'100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'flex-start',
        marginTop:'10px',
        "& span":{
            color:props.fontDarkColor ? props.fontDarkColor : '#0F467A',
            fontWeight:'bold',
            cursor:'pointer',
            alignSelf:'flex-end'
        }
    }),

    videoDiv:{
        width:'100%',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        flexWrap:'wrap'
    },

    videoInnDiv:{
        width:'70px',
        height:'70px',
        cursor:'pointer',
        position:'relative',
        marginBottom:"10px",
        borderRadius:'5px',
        "& svg":{
            fontSize:'3em',
            color:'#fff'
        }
    },

    iconDiv:{
        width:'100%',
        height:'70px',
        cursor:'pointer',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        position:'absolute',
        top:0,
        transition:'0.5s',
        zIndex:5,
        borderRadius:'5px',
        "&:hover":{
            opacity:0.5
        },
        "& svg":{
            fontSize:'3em',
            color:'#fff'
        }
    },

    reactPlayer:{
        width:'100% !important',
        height:'100% !important',
        borderRadius:'5px',
        "& video":{
            width:'100% !important',
            height:'70px !important',
            objectFit:'cover',
            borderRadius:'5px',
        },
        "& iframe":{
            borderRadius:'5px',
        }
    },

    marLeft:{
        marginLeft:'10px'
    },
    marRight:{
        marginRight:'10px'
    }
})

// Video Gallery Section
function VideoGallery(props) {
    const [videoPreviewDialog,setDialog] = React.useState(false);
    const [showItems, setShowItems] = React.useState(6);
    const [photoIndex, setIndex] = React.useState(0);
    
    const handleShowMore = () => { // pagination
        setShowItems(showItems >= videos.length ? showItems : showItems+6);
    }

    const openDialog = index => { // open video preview dialog
        setDialog(true);
        setIndex(index ? index : 0);
    }
    const closeDialog = () => { // close video preview dialog
        setDialog(false);
        setIndex(0);
    }

    const { t, i18n, videos, fontDarkColor } = props;
    const classes = useStyles({fontDarkColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <>
        <div className={classes.mainDiv}>
            <div className={classes.videoDiv}>
            {React.Children.toArray(videos.slice(0,showItems).map((v,i)=> {
                return (
                    <div className={`${classes.videoInnDiv} ${isRTL === 'ar' ? classes.marLeft : classes.marRight}`}>
                        <ReactPlayer url={v.path} className={classes.reactPlayer} />
                        <div className={classes.iconDiv} onClick={()=> openDialog(i)}>
                            <PlayCircleOutlineOutlined />
                        </div>
                    </div>
                )
            }))}
            </div>
            {/* show more button */}
            {showItems >= videos.length ?
                undefined
            :
                <span style={{fontFamily}} onClick={handleShowMore}>{t('booking.see more')}</span>
            }
        </div>
        {/* video preview dialog */}
        {videoPreviewDialog && <PhotoPreview index={photoIndex} dataArray={videos} closeEvent={closeDialog} />}
        </>
    )
}

export default withTranslation('common')(VideoGallery);